import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Divider from '@/components/UI/divider/Divider';
import Box from '@/components/UI/box/Box';
import Skeleton from '@/components/UI/skeleton/Skeleton';
import Typography from '@/components/UI/typography/Typography';
import FooterDescription from '@/components/datepicker/instanstDescriptions/InstanstPeakDescription';
import HouseDatePickerSingle from '@/components/datepicker/singleRangeDatepicker/DatePickerSingle';
import DatePickerMultiRange from '@/components/datepicker/multiRangeDatepicker/MultiDatepicker';
import DatePickerDescription from '../../datePickerDescription/DatePickerDescription';
import useDevice from '@/hooks/useDevice';
import { setBasicFilters } from '@/redux/store/actions/search';
import { CalendarPricingType } from '@/components/houses/_hooks/useProduct';
import { newDateTimeFormat } from '@/helpers/props';
import { useMidTermQuery } from '@/components/houses/_hooks/useMidterm';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
import styles from './CalendarPricing.module.scss';
const CalendarPricing: React.FC<{
  details: ProductItemTypes;
  hookData: CalendarPricingType;
}> = props => {
  const {
    hookData: {
      handleMultiCalendarChange,
      houseCalendarData,
      calendarLoading
    },
    details
  } = props;
  const {
    checkin,
    checkout,
    guests
  } = useSelector(state => state.basicFilters);
  const {
    isMidTerm
  } = useMidTermQuery(details);
  const dispatch = useDispatch();
  const {
    loading
  } = useSelector(state => state.product);
  const calendarRef = React.useRef<any | null>(null);
  const {
    isMobile
  } = useDevice();
  const handleMultiDatePickerChange = dates => {
    dispatch(setBasicFilters({
      checkin: dates.checkin,
      checkout: dates.checkout,
      guests
    }));
  };
  useEffect(() => {
    if (checkout) calendarRef?.current?.setCalendarDates(checkin, checkout);
  }, [checkin, checkout]);
  return <Box className={styles['calendar-pricing']} id="calendar" component={'section'} data-sentry-element="Box" data-sentry-component="CalendarPricing" data-sentry-source-file="CalendarPricing.tsx">
      <Divider className={styles['calendar-pricing-divider']} data-sentry-element="Divider" data-sentry-source-file="CalendarPricing.tsx" />
      {/* {details.data.pricing?.extra_person_price?.amount ||
       details.data.pricing?.records?.[0]?.extra_person.amount ||
       details.data.pricing?.records?.[0]?.long_term_discount_rate ? (
        <h3>تقویم و قیمت‌گذاری</h3>
       ) : null}
       <ul>
        {details.data.pricing?.extra_person_price?.amount ||
        details.data.pricing?.records?.[0]?.extra_person.amount ? (
          <li>
            هزینه هر نفر اضافه به ازای هر شب:{' '}
            <strong>
              {' '}
              {addCommas(
                details.data.pricing?.records === undefined
                  ? details.data.pricing?.extra_person_price.amount
                  : details.data.pricing?.records?.[0]?.extra_person.amount,
              )}
              تومان
            </strong>
          </li>
        ) : null}
        {details.data.pricing?.records?.[0]?.peak_extra_person &&
        details.data.pricing?.records?.[0]?.peak_extra_person.amount != 0 ? (
          <>
            {' '}
            <li className="peak-time">
              هزینه هر نفر اضافه در ایام پیک:
              <strong>
                {addCommas(
                  details.data.pricing?.records?.[0]?.peak_extra_person.amount,
                )}
                تومان
              </strong>
            </li>
          </>
        ) : null}
        {details.data.pricing?.records &&
        details.data.pricing?.records[0]?.short_term_discount_rate ? (
          <li>
            تخفیف کوتاه مدت:{' '}
            <strong>
              {' '}
              {details.data.pricing?.records?.[0]?.short_term_discount_rate}٪
              تخفیف برای اقامت‌های بالای{' '}
              {details.data.pricing?.records?.[0]?.short_term_discount_days} شب
            </strong>
          </li>
        ) : null}
         {details.data.pricing?.records &&
        details.data.pricing?.records[0]?.long_term_discount_rate ? (
          <li>
            تخفیف بلند مدت:{' '}
            <strong>
              {' '}
              {details.data.pricing?.records?.[0]?.long_term_discount_rate}٪
              تخفیف برای اقامت‌های بالای{' '}
              {details.data.pricing?.records?.[0]?.long_term_discount_days} شب
            </strong>
          </li>
        ) : null}
       </ul>
       {details.data.pricing?.extra_person_price?.amount ||
       details.data.pricing?.records?.[0]?.extra_person.amount ||
       details.data.pricing?.records?.[0]?.long_term_discount_rate ? (
        <Image src={smallDivider} alt="smallDivider" />
       ) : null} */}
      <Typography variant="bodyL_Bold" color="neutral_800" component="h2" data-sentry-element="Typography" data-sentry-source-file="CalendarPricing.tsx">
        انتخاب تاریخ سفر
      </Typography>
      <Box className={styles['calendar-pricing-datepicker']} data-sentry-element="Box" data-sentry-source-file="CalendarPricing.tsx">
        {!loading && houseCalendarData?.calendar && !calendarLoading && <>
            {isMobile ? <HouseDatePickerSingle dateRef={calendarRef} dates={{
          checkin,
          checkout
        }} onChange={handleMultiDatePickerChange} hasCalendar calendar={houseCalendarData.calendar} getCalendarFunc={handleMultiCalendarChange} endDay={houseCalendarData.endDay} isFull={!isMidTerm} minDays={isMidTerm && details?.pricing?.records?.[0]?.mid_term_minimum_days} nextRangeMonths={houseCalendarData.differenceInDays} footerChildren={<Box className={styles['calendar-pricing-datepicker-footer']}>
                    <FooterDescription />
                  </Box>} /> : <DatePickerMultiRange dateRef={calendarRef} dates={{
          checkin,
          checkout
        }} onChange={handleMultiDatePickerChange} hasCalendar calendar={houseCalendarData.calendar} getCalendarFunc={handleMultiCalendarChange} isFull={!isMidTerm} minDays={isMidTerm && details?.pricing?.records?.[0]?.mid_term_minimum_days} nextRangeMonths={houseCalendarData.differenceInDays} endDay={houseCalendarData.endDay} footerChildren={<Box className={styles['calendar-pricing-datepicker-footer']}>
                    {!isMidTerm ? <FooterDescription fullText /> : <DatePickerDescription discount={details?.pricing?.records[0].monthly_discount} mid_term_minimum_days={details?.pricing?.records?.[0]?.mid_term_minimum_days} />}
                  </Box>} />}
          </>}
      </Box>
      <Box className={styles['calendar-pricing-footer']} data-sentry-element="Box" data-sentry-source-file="CalendarPricing.tsx">
        <Typography variant="bodyM" color="neutral_600" data-sentry-element="Typography" data-sentry-source-file="CalendarPricing.tsx">
          آخرین به‌روزرسانی توسط میزبان:
        </Typography>
        <Typography className={styles['calendar-pricing-footer-date']} variant="bodyM_Bold" color="neutral_800" data-sentry-element="Typography" data-sentry-source-file="CalendarPricing.tsx">
          {newDateTimeFormat(details?.last_update_timestamp as string | number)?.replaceAll('-', '/')}
        </Typography>
      </Box>
    </Box>;
};
export default CalendarPricing;